import { useEffect } from 'react';

export const useInitialReferralFromUrl = () => {
  useEffect(() => {
    const referralFromUrl = new URLSearchParams(window.location.search).get('referral');
    if (referralFromUrl) {
      sessionStorage.setItem('referral', referralFromUrl);
    }
  }, []);
};
